import MapSettings from 'components/Account/MapSettings';
import React from 'react';

export default function Preferences() {
  return (
    <>
      <MapSettings />
    </>
  );
}